module.exports = "<div class=\"fukidashi_inner\" style=\"width:200px;height: auto;overflow: hidden;\">\n<a href=\"<%= url %>\" class=\"clearfix\" style=\"display:table;width:100%;\">\n\t<div class=\"img fl\" style=\"display:table-cell;width:80px;vertical-align:middle;\">\n\t\t<img src=\"<%= src %>\" alt=\"\" width=\"80\">\n\t</div>\n\t<div class=\"oh\" style=\"display:table-cell;vertical-align:middle;padding-left:10px;\">\n\t\t<h4><%= title %></h4>\n\t</div>\n</a>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./dev/js/scripts/_map_template.html
// module id = 26
// module chunks = 0